import FormContainer from "src/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { AppearanceSchema } from "@app/components/WidgetStudio/Inspector/schemas/appearance";
import {useEffect, useRef, useState} from "react";
import { InspectorProps } from "@app/components/WidgetStudio/Inspector/contracts/InspectorProps";
import { WidgetStudioDataType } from "@app/components/WidgetStudio/Inspector/schemas/widgetStudioData";

export interface AppearanceInspectorProps extends InspectorProps {}

export const AppearanceInspector = ({
  onValueChange,
  defaultFormValues,
}: AppearanceInspectorProps) => {

    const { form, schemas, zodSchema, parseForm, formValues, setFormValues } =
        useFormWithSchema<WidgetStudioDataType>({
            formSchemas: AppearanceSchema,
            defaultFormValues: defaultFormValues,
            mode: "onChange",
        });

    useEffect(() => {
        if (defaultFormValues.size != formValues.size || defaultFormValues.shape != formValues.shape){
            setFormValues(defaultFormValues);
        }
    }, [defaultFormValues])


  useEffect(() => {
    onValueChange(formValues);
  }, [formValues]);

  return (
    <div className="flex flex-col">
      <FormContainer schemas={schemas} form={form} />
    </div>
  );
};
